import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import HomeScreen from './screens/HomeScreen'
import ProductScreen from './screens/ProductScreen'
import CartScreen from './screens/CartScreen'
import LoginScreen from './screens/LoginScreen'
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen'
import ShippingScreen from './screens/ShippingScreen'
import PaymentScreen from './screens/PaymentScreen'
import PlaceOrderScreen from './screens/PlaceOrderScreen'
import OrderScreen from './screens/Order/OrderScreen'
import UserListScreen from './screens/UserListScreen'
import CustomerListScreen from './screens/CustomerListScreen'
import CustomerDetailScreen from './screens/CustomerDetailScreen'
import UserEditScreen from './screens/UserEditScreen'
import ProductListScreen from './screens/ProductListScreen'
import CategoryEditScreen from './screens/admin/category/CategoryEditScreen'
import OrderListScreen from './screens/OrderListScreen'
import DraftOrderListScreen from './screens/DraftOrderListScreen'
import ProductCreateScreen from './screens/ProductCreateScreen'
import MenuScreen from './screens/admin/menu/MenuScreen'
import MenuListScreen from './screens/admin/menu/MenuListScreen'
import MobileMenuScreen from './screens/admin/menu/MobileMenuScreen'
import MobileMenu from './screens/admin/menu/MobileMenu'
import BrandScreen from './screens/admin/BrandScreen'
import CategoryScreen from './screens/category/CategoryScreen'
import categoryAdmin from './screens/admin/category/categoryAdmin'
import CategoryCreateScreen from './screens/admin/category/CategoryCreateScreen'
import HomepageScreen from './screens/admin/homepage/HomepageScreen'
import MenuCreateScreen from './screens/admin/menu/MenuCreateScreen'
import BannerScreen from './screens/admin/banner/BannerScreen'
import FilterTemplateScreen from './screens/admin/FilterTemplateScreen'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from './components/PrivateRoute/PrivateRoute'

const App = () => {
  return (
    <Router>
      <Header />

      <PrivateRoute path='/' component={ProductListScreen} exact />

      <PrivateRoute path='/order/:id' component={OrderScreen} />

      <PrivateRoute path='/shipping' component={ShippingScreen} />
      <PrivateRoute path='/payment' component={PaymentScreen} />
      <PrivateRoute path='/placeorder' component={PlaceOrderScreen} />
      <Route path='/login' component={LoginScreen} />
      <Route path='/register' component={RegisterScreen} />
      <PrivateRoute path='/profile' component={ProfileScreen} />
      <PrivateRoute path='/product/:id' component={ProductScreen} />
      <PrivateRoute path='/cart/:id?' component={CartScreen} />
      <PrivateRoute path='/admin/userlist' component={UserListScreen} />
      <PrivateRoute path='/admin/customers' component={CustomerListScreen} exact />
      <PrivateRoute path='/admin/customer/:id' component={CustomerDetailScreen} />
      <PrivateRoute path='/admin/user/:id/edit' component={UserEditScreen} />
      <PrivateRoute path='/admin/productlist' component={ProductListScreen} exact />

      <PrivateRoute path='/category/:id' component={CategoryScreen} />
      <PrivateRoute path='/search' component={CategoryScreen} />

      <PrivateRoute path='/admin/productlist/:pageNumber' component={ProductListScreen} exact />
      <PrivateRoute path='/admin/product/:id/edit' component={ProductCreateScreen} />
      <PrivateRoute path='/admin/product/create' component={ProductCreateScreen} />

      {/* Menu admin screens  */}
      <PrivateRoute path='/admin/menu/create' component={MenuCreateScreen} />
      <PrivateRoute path='/admin/menus' component={MenuListScreen} />
      <PrivateRoute path='/admin/menu/edit/:id' component={MenuScreen} />

      {/* Mobile Menu admin screens  */}
      <PrivateRoute path='/admin/mobile-menu' component={MobileMenuScreen} exact />
      <PrivateRoute path='/admin/mobile-menu/edit/:id' component={MobileMenu} />

      {/* Brand admin screens  */}
      <PrivateRoute path='/admin/brands' component={BrandScreen} />

      {/* Homepage admin screens  */}
      <PrivateRoute path='/admin/homepage' component={HomepageScreen} />
      <PrivateRoute path='/admin/banners' component={BannerScreen} />

      {/* Order admin screens  */}
      <PrivateRoute path='/admin/orderlist' component={OrderListScreen} />
      <PrivateRoute path='/admin/draftorders' component={DraftOrderListScreen} />
      <PrivateRoute path='/page/:pageNumber' component={HomeScreen} exact />

      {/* Filter Templates */}
      <PrivateRoute path='/admin/filter-templates' component={FilterTemplateScreen} />

      {/* Category Admin Screens  */}
      <PrivateRoute path='/admin/categoryList' component={categoryAdmin} />


      <PrivateRoute path='/admin/category/edit/:id' component={CategoryEditScreen} />
      <PrivateRoute path='/admin/category/create/' component={CategoryCreateScreen} />

<ToastContainer position="top-right" style={{ zIndex: 999999 }} />

      <Footer />
    </Router>
  )
}

export default App
